import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
	data: () => ({
		
	}),

	computed: {
		...mapGetters('VehicleParam', [ 'params', 'favorits' ]),

		rules() {
			return {
				required: (value) => !!value || "Обов'язкове для заповнення",
				requiredNumber: (value) => !!value || this.params.tab!='number' || "Обов'язкове для заповнення",
				requiredVIN: (value) => !!value || this.params.tab!='vin' || "Обов'язкове для заповнення",
				vehicleNumber: (value) => {
					const pattern = /^([a-zA-Zа-яА-ЯІіЇї'\-]+)/
					return (value && value.length > 10 && pattern.test(value)) || 'І\'мя некоректне'
				},
				vin: (value) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					return pattern.test(value) || 'Некоректний e-mail.'
				},
			}
		},

		favorit() {
			return this.favorits.find(element => element.code === this.code);
		},

		isFavorit() {
			return this.favorit ? true : false
		},
	},

	methods: {
		...mapActions('VehicleParam', [ 'setParams', 'addFavorit', 'removeFavorit' ]),
		
		isVin(input) {
			const cleanInput = input.replace(/\s|-/g, '').toUpperCase(); // Видаляємо пробіли і дефіси
			return cleanInput.length === 17 && /^[A-HJ-NPR-Z0-9]+$/.test(cleanInput);
		},

		isLicensePlate(input) {
			const cleanInput = input.replace(/\s|-/g, '').toUpperCase(); // Видаляємо пробіли і дефіси
			return /^[A-ZА-ЯІЇЄ0-9]{6,9}$/.test(cleanInput);
		},

		onClear() {
			this.$refs.form.reset()
		},

		onFavorit(favorit) {
			//console.log(this.$options.name, 'onFavorit','favorit', favorit)

			let params = {...favorit};

			//Видалення параметрів number та vin
			if(params?.number) delete params.number;
			if(params?.vin) delete params.vin;

			params['use'] = {}

			this.setParams(params)

			//favorit['mileage'] = []
			//favorit['engineVolume'] = []
			/* favorit['use'] = {}
			this.setParams({...favorit}) */

			//console.log(this.$options.name, 'onFavorit','params', this.params)
		},
	},
}